import { observer } from "mobx-react";
import { PriceFormats, SummaryColumns } from "@repo/utils";
import { useEstimateStructure, useVisibilityModeCellClassName, ValueCell } from "@tools";

export const MaterialsCostCell = observer((cellProps) => {
  const structure = useEstimateStructure();
  const { displayBreakdownMaterialPrice, showFixedDecimalPrices } = structure;
  const { currencyObj, roundPrice, priceFormat } = structure.settings;
  const { hideSummaryCost } = structure.visibility;
  const className = useVisibilityModeCellClassName(hideSummaryCost);
  
  return (
    <ValueCell
      colName={ SummaryColumns.COST }
      useDynamicWidth
      displayContent
      useInputBackground
      usePriceFormat
      applySuffixSpacing
      value={displayBreakdownMaterialPrice}
      showDecimals={!roundPrice}
      fixedDecimalScale={showFixedDecimalPrices}
      symbolStart={currencyObj.symbolStart}
      symbolEnd={currencyObj.symbolEnd}
      americanFormat={priceFormat === PriceFormats.AMERICAN}
      allowNegative
      className={className}
      textPresetClass="preset-price"
      {...cellProps}
    />
  );
});
